import { make } from "vuex-pathify";

const state = {
	show: false,
	action: 'move',
	articles: []
};

const getters = {};

const mutations = {
	...make.mutations(state)
};

const actions = {
	/**
	 * Shows/opens BulkDialog component and sets initial values
	 * action - Type of action: 'move', 'copy', 'change-category'
	 * articles - Array of articles selected, or array of one article
	 */
	openArticleBulkDialog({ commit }, { action, articles }) {
		commit('SET_SHOW', true);
		commit('SET_ACTION', action);
		commit('SET_ARTICLES', articles);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
